"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _UsageTracker = require("MeetingsLib/tracking/UsageTracker");

var _utils = require("MeetingsLib/utils/utils");

var _Big = _interopRequireDefault(require("UIComponents/elements/Big"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _default = (0, _createReactClass.default)({
  propTypes: {
    profile: _propTypes.default.instanceOf(_UserProfile.default).isRequired,
    linkUse: _propTypes.default.string,
    TimePickerMarker: _propTypes.default.func.isRequired
  },
  renderZeroStateText: function renderZeroStateText() {
    var profile = this.props.profile;
    var options = {
      fullName: (0, _utils.getLongDisplayName)(profile)
    };
    (0, _UsageTracker.track)('meetingsLibViewScreen', {
      stage: 'no availability'
    });
    return _react.default.createElement(_FormattedMessage.default, {
      message: "prebook.timeOptions.zeroState",
      options: options
    });
  },
  render: function render() {
    var _this$props = this.props,
        profile = _this$props.profile,
        linkUse = _this$props.linkUse,
        TimePickerMarker = _this$props.TimePickerMarker;
    return _react.default.createElement("div", {
      className: "text-center m-top-10 prebook-zero-state"
    }, _react.default.createElement(_H.default, {
      "aria-level": 2
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "prebook.timeOptions.sorry"
    })), _react.default.createElement(_Big.default, null, _react.default.createElement("p", {
      tabIndex: "0"
    }, this.renderZeroStateText()), _react.default.createElement(_UILink.default, {
      use: linkUse,
      href: "mailto:" + profile.email
    }, profile.email)), _react.default.createElement(TimePickerMarker, null));
  }
});

exports.default = _default;
module.exports = exports.default;